import React, { Component } from "react";
import { connect } from "react-redux";
import NumberFormat from "react-number-format";

class CheckoutSideTotals extends Component {
	render() {
		const { cart, checkout } = this.props;

		return (
			<div className="section">
				<div className="section-heading section--side-heading">
					<span className="txt">Order Total</span>
					<span className="content">
						<NumberFormat value={cart.total} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={"$"} />
					</span>
				</div>
				<div className="section-content">
					<table className="cart-total-summary">
						<tbody>
							<tr>
								<th>Our Price</th>
								<td>
									<NumberFormat value={cart.sub_total} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={"$"} />
								</td>
							</tr>
							<tr>
								<th>Shipping & Handling</th>
								<td>
									<div className="hbs-shipping-cost">{cart.shipping ? <NumberFormat value={cart.shipping.cost} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={"$"} /> : !!checkout.shipping ? <NumberFormat value={checkout.shipping.shipping_cost} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={"$"} /> : <span className="no-value">-</span>}</div>
								</td>
							</tr>
							<tr>
								<th>Tax Applied</th>
								<td>{!!cart.taxes ? <NumberFormat value={cart.taxes.total} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={"$"} /> : <span className="no-value">-</span>}</td>
							</tr>
							{cart.promo_applied && (
								<tr>
									<th>Promo Applied</th>
									<td>{cart.promo_applied}</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		cart: state.cart,
		checkout: state.checkout
	};
};

export default connect(mapStateToProps)(CheckoutSideTotals);



// WEBPACK FOOTER //
// ./src/components/checkout/side-summary/CheckoutSideTotals.js